import plusIcon from "../../../../images/plus-solid.png";
import checkIcon from "../../../../images/check-solid.png";
import * as CommonUtilities from "../../../../common/utils/CommonUtils";

export default function ModifierComboGroupButton(props) {
    // Returns Group button displayed in group container inside a modifier combo

    let buttonImageToDisplay;
    let productTextDisplay;
    let modifierDisplayContainer, priceInc, priceIncToDisplay = "";
    let hasErrorClass = "";
    /* ⚠ Keep "is-invalid" exactly as it is. The error text below is Bootstrap's
       .invalid-feedback, which stays display:none unless a sibling carries
       .is-invalid — drop it and the customer is blocked with no reason shown. */
    if (props.modComboGroupFormData.ValidationModComboGroup.HasError) {
        hasErrorClass = "is-invalid wo-combo__btn--bad";
    } else {
        hasErrorClass = "";
    }

    if (props.modComboGroupFormData.Quantity === 0 || props.modComboGroupFormData.Quantity === '0') {
        productTextDisplay = `Choose ${props.modifierComboGroupDetails.modCategoryName}`
        buttonImageToDisplay = <span className="wo-combo__mark"><img src={plusIcon} alt="Add" title="Add" style={{width: "10px"}}></img></span>
        modifierDisplayContainer = <></>;
    } else {
        // Format price to display
        priceIncToDisplay = CommonUtilities.formatDisplayPrice(props.modComboGroupFormData.PriceInc);
        productTextDisplay = `${props.modifierComboGroupDetails.modCategoryName}`
        buttonImageToDisplay = <span className="wo-combo__mark wo-combo__mark--on"><img src={checkIcon} alt="Selected" style={{width: "10px"}}></img></span>
        modifierDisplayContainer =
            <ul className="wo-combo__picks">
                <li>{props.modComboGroupFormData.ModifierName}<span className="ms-2 ps-1">{priceIncToDisplay}</span></li>
            </ul>
    }

    return (
        <>
            <div className="col-12 wo-combo">
                <button type="button" className={`wo-combo__btn ${hasErrorClass}`} data-modcombogroupindex={props.modComboGroupIndex} onClick={props.handleModifierComboGroupSelect}>
                    {buttonImageToDisplay}
                    <span className="wo-combo__text">
                        <span className="wo-combo__name">{productTextDisplay}</span>
                        {modifierDisplayContainer}
                    </span>
                </button>
                <div className="invalid-feedback">{props.modComboGroupFormData.ValidationModComboGroup.ErrorMessage}</div>
            </div>
        </>
    )
}